import { render, staticRenderFns } from "./MfaWidget.vue?vue&type=template&id=6c837c23&scoped=true"
import script from "./MfaWidget.vue?vue&type=script&lang=ts"
export * from "./MfaWidget.vue?vue&type=script&lang=ts"
import style0 from "./MfaWidget.vue?vue&type=style&index=0&id=6c837c23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c837c23",
  null
  
)

export default component.exports